var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRetry = function SvgRetry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M510.66 957.4A447.26 447.26 0 0 1 336.6 98.25a447.6 447.6 0 0 1 567.23 198.83 35 35 0 1 1-61.51 33.42 377.17 377.17 0 1 0 1.75 356.24 35 35 0 1 1 61.83 32.81A447.11 447.11 0 0 1 510.66 957.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M890.39 390.73q-3.75 0-7.54-.36l-.64-.06-156-17.69a35 35 0 1 1 7.89-69.55l155.55 17.64a8.58 8.58 0 0 0 1.92 0v-.23l-11.76-145a35 35 0 1 1 69.77-5.66l11.76 145c1.71 21.12-5.63 41.44-20.15 55.75-13.19 13-31.41 20.16-50.8 20.16"
  })));
};
export default SvgRetry;